import { render, staticRenderFns } from "./BibliographicResourcesComponent.vue?vue&type=template&id=16991090&scoped=true"
import script from "./BibliographicResourcesComponent.vue?vue&type=script&lang=js"
export * from "./BibliographicResourcesComponent.vue?vue&type=script&lang=js"
import style0 from "./BibliographicResourcesComponent.vue?vue&type=style&index=0&id=16991090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16991090",
  null
  
)

export default component.exports